export default __webpack_public_path__ + "static/media/SENAIT_FR_SEQ18.3e98776d.mp3";